

import React from 'react';
import SimpleContent from './Content/SimpleContent';
import BioContent from './Content/BioContent';

import './TileSelection.css';

const TileSection: React.FC<TileSection> = ({ type, isImgLeft, imgSrc, content, moreInfoSrc }) => {


    return (
        <div className='tileSection'>
            <div className='flexContainer'>
                {isImgLeft == null || !isImgLeft ? (<></>) : (
                    <div className='column'>
                        {type == 2 ? (
                            <div className='background'>
                                <video autoPlay
                                    loop
                                    muted
                                    playsInline controls className='video'>
                                    <source src={imgSrc == null ? "" : imgSrc} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        ) : (
                            <div className='imgBackground'>
                                <img
                                    loading="lazy"
                                    src={imgSrc == null ? "" : imgSrc}
                                    className='image'
                                    alt={content.title}
                                />
                            </div>
                        )}
                    </div>
                )}
                <div className='column'>
                    <section className='content'>
                        {type == 0 || type == 2 ? (
                            <SimpleContent title={content.title} body={(content as SimpleContent).body} footNote={(content as SimpleContent).footNote} hasMoreInfo={(content as SimpleContent).hasMoreInfo} moreInfoSrc={moreInfoSrc} />
                        ) : (
                            <BioContent title={content.title} body={(content as SimpleContent).body} footNote={(content as SimpleContent).footNote} hasMoreInfo={(content as SimpleContent).hasMoreInfo} />
                        )}
                    </section>
                </div>
                {isImgLeft == null || isImgLeft ? (<></>) : (
                    <div className='column'>

                        {type == 2 ? (
                            <video width="50%" controls className='video'>
                                <source src={imgSrc == null ? "" : imgSrc} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        ) : (

                            <div className='imgBackground'>
                                <img
                                    loading="lazy"
                                    src={imgSrc == null ? "" : imgSrc}
                                    className='image'
                                    alt={content.title}
                                />
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>

    );
};

export default TileSection;